import axios from "axios";
import { IP } from "../index";
// 查询
export async function selectApi(data) {
  var resp = await axios.post(`${IP}/sendService/sendCycle/select`, {
    ...data,
  });
  return resp.data;
}

// 新增
export async function addApi(data) {
  var resp = await axios.post(`${IP}/sendService/sendCycle/add`, {
    ...data,
  });
  return resp.data;
}

/* 修改 */
export async function updateApi(data) {
  var resp = await axios.post(`${IP}/sendService/sendCycle/update`, {
    ...data,
  });
  return resp.data;
}

// 删除
export async function deleteApi(data) {
  var resp = await axios.post(`${IP}/sendService/sendCycle/delete`, {
    ...data,
  });
  return resp.data;
}
